export const UPLOAD_SENDING = 'UPLOAD_SENDING';

export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS';

export const UPLOAD_FAILED = 'UPLOAD_FAILED';

export const DELETE_UPLOADED = 'DELETE_UPLOADED';

